import ActionButton from '@/components/Button/ActionButton';
import Icon from '@/components/Icon/Icon';
import { HStack } from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';

import type { EditButtonGroupProps } from '../cform-types';

/**
 * アイテムごとの
 * 編集 / キャンセル・保存ボタン
 */
export function CFormItemEditButtonGroup(props: EditButtonGroupProps) {
  const tc = useCommonTranslation();

  if (!props.display) return null;

  return !props.isEditing ? (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9 p-0"
      onClick={props.onStartEdit}
    >
      <Icon iconName="PencilIcon" size={14} />
    </Button>
  ) : (
    <HStack className="gap-2">
      <ActionButton
        onClick={props.onCancel}
        size="sm"
        variant="outline"
        disabled={props.isPending}
      >
        {tc('action.cancel')}
      </ActionButton>
      <ActionButton
        onClick={props.onSave}
        size="sm"
        isLoading={props.isPending}
      >
        {tc('action.save')}
      </ActionButton>
    </HStack>
  );
}
